import { render, staticRenderFns } from "./bankEdit.vue?vue&type=template&id=6db0b34e&scoped=true&"
import script from "./bankEdit.vue?vue&type=script&lang=js&"
export * from "./bankEdit.vue?vue&type=script&lang=js&"
import style0 from "./bankEdit.vue?vue&type=style&index=0&id=6db0b34e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db0b34e",
  null
  
)

export default component.exports